import { get } from 'lodash';

export default [
  '$scope',
  'options',
  'apiService',
  '$uibModalInstance',
  '$q',
  function ($scope, options, apiService, $uibModalInstance, $q) {
    const autoProlong = false;
    const realtyObjectId = options.offerId;

    this.highlightOption = options.highlightOption;
    this.offerTerms = options.offerTerms;
    this.terms = [];

    this.onTermsChange = terms => {
      this.terms = terms;
    };

    this.loading = false;
    this.buy = () => {
      this.loading = true;

      apiService
        .ajaxPublishOffer({
          autoProlong,
          publishServices: this.terms,
          realtyObjectId,
        })
        .then(res => {
          const status = get(res, 'data.status');
          const publishStatus = get(res, 'data.publishStatus');
          if (status !== 'ok' || publishStatus !== 'success') {
            return $q.reject(res);
          }
          $uibModalInstance.close('success');
        })
        .catch(err => {
          $uibModalInstance.dismiss({ $error: err });
        })
        .finally(() => {
          this.loading = false;
        });
    };
  },
];
